import {Component, effect, input, WritableSignal} from '@angular/core'
import {BaseTable, BindingPipe} from '@sparbanken-syd/sparbanken-syd-theme'
import {InterestInput} from '../interest-input/interest-input'
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from '@angular/material/table'

@Component({
  selector: 'spb-binding-discount',
  imports: [
    BindingPipe,
    InterestInput,
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    MatHeaderCellDef
  ],
  templateUrl: './binding-discount.html',
  // Borrow some styles..
  styleUrl: '../production-price-table/production-price-table.scss'
})
export class BindingDiscount extends BaseTable<WritableSignal<number>[]> {

  /* v8 ignore next */
  public discounts =
    input.required<WritableSignal<number>[][]>()

  public bindings = [3, 12, 24, 36, 48, 60, 84, 120]

  constructor() {
    super()
    this.columns.set(this.bindings.map(b => `${b}`))
    effect(() => {
      this.items.data = this.discounts()
    })
  }
}
